import {
  Component,
  Input,
  ContentChildren,
  Renderer2,
  ElementRef,
  OnInit,
  Directive, QueryList, TemplateRef, ContentChild
} from '@angular/core';

import {NgbDropdown} from '..';


@Directive({selector: '[cloButtonLabel]'})
export class CloButtonLabel {
}

@Directive({
  selector: 'clo-split-item'
})
export class CloSplitItems {

}


/**
 * Buttons are used to make common actions immediately visible and easy to perform with one click, tap, or keypress.
 * Merchants can use them to navigate or to take action.
 *
 * It supports several button types.
 */
@Component({
  selector: 'clo-button',
  templateUrl: './button.html',
  styleUrls: ['./button.scss']
})
export class CloButton implements OnInit {

 private _hasChildren: boolean;
  @ContentChildren(CloSplitItems) dropdownItems: QueryList<CloSplitItems>;

  @Input() label: string;

  /**
   * If `true`, alert can be dismissed by the user.
   *
   * The close button (×) will be displayed and you can be notified
   * of the event with the `(close)` output.
   */
  @Input() disabled: boolean;
  /**
   * Type of the alert.
   *
   *  The following types are supported: `'success'`, `'warning'`, `'error'`, `'no-internet'`,
   *  `'success-textOnly'`, `'warning-textOnly'`, `'error-textOnly'`,
   */
  @Input() type: string;



  constructor(private _renderer: Renderer2, private _element: ElementRef) {
    this._hasChildren = (this.dropdownItems !== undefined) && (this.dropdownItems.length > 0);
  }
  get hasChildren(): boolean { return this._hasChildren; }

  ngOnInit() {
  }
}
